import { I18n } from "~/js/tools/i18n";

/**
 * @param container {HTMLDivElement}
 * @param settings {DataForm}
 **/
function hasAmountLimit(container, settings) {
  const $i18n = new I18n(["ru", "ru", "en"][settings.languageId]);
  container.classList.add("qform-has-amount-limit");
  container.innerHTML = `
        <div>
            <i>
                <span>                
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7 10.6667C7.84219 10.6667 8.53125 10.0667 8.53125 9.33333C8.53125 8.6 7.84219 8 7 8C6.15781 8 5.46875 8.6 5.46875 9.33333C5.46875 10.0667 6.15781 10.6667 7 10.6667ZM11.5938 4.66667H10.8281V3.33333C10.8281 1.49333 9.11312 0 7 0C4.88688 0 3.17188 1.49333 3.17188 3.33333V4.66667H2.40625C1.56406 4.66667 0.875 5.26667 0.875 6V12.6667C0.875 13.4 1.56406 14 2.40625 14H11.5938C12.4359 14 13.125 13.4 13.125 12.6667V6C13.125 5.26667 12.4359 4.66667 11.5938 4.66667ZM4.62656 3.33333C4.62656 2.19333 5.69078 1.26667 7 1.26667C8.30922 1.26667 9.37344 2.19333 9.37344 3.33333V4.66667H4.62656V3.33333ZM11.5938 12.6667H2.40625V6H11.5938V12.6667Z" fill="white"/>
                    </svg> 
                </span>           
            </i>
            <span style="font-size: x-large;">${$i18n.t("restrictions.hasAmountLimit.formIsUnavailable")}</span>
        </div>        
        <p>${$i18n.t("restrictions.hasAmountLimit.hint")}</p>
    `;
}
export default hasAmountLimit;